module.exports = __webpack_public_path__ + "img/hb.7e7f8e08.jpg";